import WhatsUpIcon from "assets/icons/WhatsUpIcon";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { sendMessage } from "./config";
import { messages } from "./LimitsPage";
import useProfileData from "hooks/useProfileData";
import Button from "features/newLanding/Button/Button";

const ContactUsPage = () => {
  const navigate = useNavigate();
  const { profile = {} } = useProfileData();
  const { show, update, boot } = useIntercom();

  useEffect(() => {
    boot({
      hideDefaultLauncher: true,
      hide_default_launcher: true,
    });
  }, [boot]);

  const handleOpenWhatsUp = () => {
    const message = profile?.verified ? messages?.downgrade : messages.upgrade;
    sendMessage(message, show, update);
  };

  const handleOpenInbox = () => {};

  return (
    <div
      className={` px-5  flex flex-col sm2:w-[400px]  justify-between sm1:justify-start mx-auto   pb-5
    
    `}
    >
      <div className="divide-y-reverse  border-[#efeff0]">
        {/* */}
        <div className="w-full   relative flex mx-auto  items-center py-3    ">
          <img
            src="/svg/leftArrow.svg"
            alt="left"
            className="cursor-pointer "
            onClick={() => navigate("/profile")}
          />

          <p className=" absolute left-1/2 transform -translate-x-1/2 font-bold   text-lg ">
            Help
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-[10px] pt-5">
        <p className="font-bold text-2xl">Contact us</p>
        <a href="mailto:info@keepz.me">
          <div className="h-[60px] bg-[#fafafa] flex items-center gap-[15px] p-5 rounded-2xl">
            <img src="svg/envelope2.svg" alt="" />
            <p>support@keepz.me</p>
          </div>
        </a>
        <Button
          className="h-[60px] bg-[#fafafa] flex items-center  gap-[15px]  p-5  rounded-2xl"
          onClick={handleOpenWhatsUp}
        >
          <WhatsUpIcon fill="#6C63FF" onlyIcon={true} />
          <p>+995 591 05 00 02</p>
        </Button>
      </div>
    </div>
  );
};

export default ContactUsPage;
